import React from 'react';
import { ButtonRow, TableContainer } from './styles';
import { FaTrash } from 'react-icons/fa';
import { GoPencil } from 'react-icons/go';
import { useClassificacaoIbsCbs } from '../../../hooks/useClassificacaoIbsCbs';
import { deleteItens } from '~/utils/masterDetail';
import { DataGrid, GridColDef } from '@material-ui/data-grid';
import { formatCurrencyAsText } from '~/utils/functions';

export const TableIBS: React.FC = () => {
  const {
    formUF: { reset },
    rowsUf,
    setRowsUf,
    masterDetail,
    setMasterDetail,
    setUpdateItem,
  } = useClassificacaoIbsCbs();

  const columns: GridColDef[] = [
    {
      field: 'des_sigla',
      headerName: 'UF',
      headerAlign: 'center',
      width: 80,
      align: 'center',
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return <span>{row.des_sigla.label}</span>;
      },
    },
    {
      field: `per_aliq_ibs_est`,
      headerName: 'IBS Estadual',
      headerAlign: 'right',
      align: 'right',
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return <span>{formatCurrencyAsText(row.per_aliq_ibs_est)}</span>;
      },
    },
    {
      field: `per_aliq_ibs_mun`,
      headerName: 'IBS Municipal',
      headerAlign: 'right',
      align: 'right',
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return <span>{formatCurrencyAsText(row.per_aliq_ibs_mun)}</span>;
      },
    },
    {
      field: `per_red_ibs`,
      headerName: '% Redução',
      headerAlign: 'right',
      align: 'right',
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return <span>{formatCurrencyAsText(row.per_red_ibs)}</span>;
      },
    },
    {
      field: 'acoes',
      headerName: 'Ações',
      width: 150,
      sortable: false,
      disableColumnMenu: true,
      align: 'center',
      headerAlign: 'center',
      headerClassName: 'hideRightSeparator',
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            <ButtonRow
              type="button"
              onClick={() => onEditItem(row)}
              isBlocked={false}
              disabled={false}
              title="Editar"
            >
              <GoPencil size={20} style={{ color: '#72ab90' }} />
            </ButtonRow>
            <ButtonRow
              type="button"
              onClick={() => onRemoveItem(row.uuid)}
              isBlocked={false}
              disabled={false}
              title="Excluir"
            >
              <FaTrash size={20} style={{ color: '#e63c3c' }} />
            </ButtonRow>
          </>
        );
      },
    },
  ];

  const onEditItem = async (data: any) => {
    setUpdateItem(true);
    reset({
      des_sigla: data.des_sigla,
      per_aliq_ibs_est: formatCurrencyAsText(data.per_aliq_ibs_est),
      per_aliq_ibs_mun: formatCurrencyAsText(data.per_aliq_ibs_mun),
      per_red_ibs: formatCurrencyAsText(data.per_red_ibs),
    });
  };

  const onRemoveItem = async (uuid: string) => {
    const rowsDetail: any = deleteItens(
      'ufs',
      uuid,
      masterDetail,
      setMasterDetail,
    );
    setRowsUf(rowsDetail);
    setUpdateItem(false);
    reset();
  };

  return (
    <TableContainer>
      <DataGrid
        rowsPerPageOptions={[5]}
        className="table"
        rows={rowsUf}
        columns={columns}
        pageSize={5}
        getRowId={(row) => row.uuid}
        autoHeight
        disableColumnSelector
        disableColumnFilter
        disableSelectionOnClick
        localeText={{
          noRowsLabel: 'Nenhum registro encontrado...',
          columnMenuLabel: 'Menu',
          columnMenuFilter: 'Filtrar',
          columnMenuHideColumn: 'Esconder',
          columnMenuUnsort: 'Não ordenar',
          columnMenuSortAsc: 'Ordernar ASC',
          columnMenuSortDesc: 'Ordernar DESC',
          columnMenuShowColumns: 'Mostrar columnas',
        }}
      />
    </TableContainer>
  );
};
